import Add from './add/CanAddContactCountInitialState'

const { Record } = require('immutable');

export default Record({
    add: Add()
});